import { useState, useEffect } from 'react';

/**
 * Custom hook to detect mobile viewport
 * @param {number} breakpoint - Width in pixels to define mobile (default: 768)
 * @returns {boolean} - Returns true if the viewport is mobile
 */
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // 1. Define the media query
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    
    // 2. Define the handler function
    const onChange = (e) => {
      setIsMobile(e.matches);
    };

    // 3. Set initial value
    setIsMobile(mql.matches);

    // 4. Add listener (Modern API)
    mql.addEventListener('change', onChange);

    // 5. Cleanup to prevent memory leaks
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  return isMobile;
}